import { useCallback, useEffect, useRef, useState } from "react";
import logo from "../../../assets/logo.svg";
import L from "../../../constants/baysportLabels";
import s from "./clientApp.module.css";

/** Статичный экран — только для PortalGate / WithRole, без анимации */
export function ClientSplashStatic() {
  return (
    <div className={s.splashStatic} role="status" aria-label="Загрузка" />
  );
}

const TIMING = {
  text: 1200,
  exit: 2700,
  done: 3600,
};

/** На iOS PWA таймеры иногда не срабатывают — принудительно завершаем splash. */
const SAFETY_DONE_MS = 4500;

export default function ClientSplash({ clubName, onComplete }) {
  const [phase, setPhase] = useState("logo");
  const onCompleteRef = useRef(onComplete);
  const finishedRef = useRef(false);
  onCompleteRef.current = onComplete;

  const finish = useCallback(() => {
    if (finishedRef.current) return;
    finishedRef.current = true;
    onCompleteRef.current?.();
  }, []);

  useEffect(() => {
    const toText = setTimeout(() => setPhase("text"), TIMING.text);
    const toExit = setTimeout(() => setPhase("exit"), TIMING.exit);
    const done = setTimeout(finish, TIMING.done);
    const safety = setTimeout(finish, SAFETY_DONE_MS);
    return () => {
      clearTimeout(toText);
      clearTimeout(toExit);
      clearTimeout(done);
      clearTimeout(safety);
    };
  }, [finish]);

  return (
    <div
      className={s.splash}
      data-phase={phase}
      role="status"
      aria-live="polite"
      aria-label="Загрузка"
    >
      <div className={s.splashBg} aria-hidden />
      <div className={s.splashStage}>
        <div className={s.splashLogoLayer} aria-hidden={phase !== "logo"}>
          <div className={s.splashLogoCard}>
            <img src={logo} alt="" className={s.splashLogo} width={72} height={72} />
          </div>
        </div>
        <div className={s.splashTextLayer} aria-hidden={phase === "logo"}>
          <h1 className={s.splashBrand}>{L.productName}</h1>
          <p className={s.splashTagline}>{clubName || "Ваш спортивный клуб"}</p>
        </div>
      </div>
    </div>
  );
}
